export default __webpack_public_path__ + "static/media/member-4.141cc9a4.png";